import { ObjectMapper } from 'json-object-mapper';
import { IModel } from '../IModel';
import { Model } from '../model';

export class ModuleActionModel extends Model implements IModel<ModuleActionModel> {
    moduleUrlId: string | undefined = undefined;
    action: string = '';
    alias: string = '';
    isFullControl: boolean = false;
    moduleUrl: string = '';

    static create(input: any): ModuleActionModel {
        return ObjectMapper.deserialize<ModuleActionModel>(ModuleActionModel, input);
    }

    public toJSON(): string {
        return ObjectMapper.serialize(this) as string;
    }
}
